<template>
  <v-dialog
    :value="value"
    :overlay-color="overlayColor"
    :overlay-opacity="overlayOpacity"
    :width="width"
    :attach="attach"
    :scrollable="scrollable"
    content-class="brazil-dialog"
    @input="$emit('change', !value)"
  >
    <div class="dialog-content-container">
      <div class="header">
        <h4 v-if="header">
          {{ header }}
        </h4>
        <img
          id="close-modal"
          src="~images/svg/close_icon.svg"
          @click="$emit('change', !value)"
        >
      </div>
      <slot />
    </div>
  </v-dialog>
</template>

<script>
import { VDialog } from 'vuetify/lib';

export default {
  name:       'BrazilVDialog',
  components: {
    VDialog,
  },
  model: {
    prop:  'value',
    event: 'change',
  },
  props: {
    value: {
      type:    Boolean,
      default: false,
    },
    width: {
      type:    String,
      default: 'auto',
    },
    attach: {
      type:     String,
      required: false,
      default:  '',
    },
    header: {
      type:     String,
      required: false,
      default:  '',
    },
    overlayColor: {
      type:    String,
      default: '#f4f4f4',
    },
    overlayOpacity: {
      type:    Number,
      default: 0.6,
    },
    scrollable: {
      type:    Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
  .v-dialog.brazil-dialog {
    box-shadow: none;
    background-color: #ffffff;
    border: 4px solid rgb(237, 191, 66);
    border-radius: 0;
    position: relative;
    flex-direction: column;
    overflow-y: visible;
    max-width: 550px;
  }

  .dialog-content-container {
    overflow-y: auto;
  }

  #close-modal {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 30px;
    &:hover {
      cursor: pointer;
    }
  }

  .v-dialog.brazil-dialog .header h4 {
    font-weight: bold;
    padding: 4px 12px;
  }

  @media screen and (max-width: 500px) {
    .v-dialog.brazil-dialog .header h4 {
      font-size: 18px;
    }
  }
</style>
